module.exports = __webpack_public_path__ + "img/go6.c4a6dcc0.png";